type CareersTranslation = {
  [key in 'en' | 'na' | 'uk' | 'nl' | 'fr' | 'pl' | 'de' | 'es' | 'fi' | 'it' | 'na-fr' | 'au']: string
}

export const translatedCareersSlug: CareersTranslation = {
  en: 'careers',
  uk: 'careers',
  na: 'careers',
  nl: 'werken-bij-refresco',
  fr: 'nous-rejoindre',
  pl: 'kariera',
  de: 'karriere',
  es: 'unete-al-equipo',
  fi: 'tyoskentely-refrescossa',
  it: 'lavorare-in-Refresco',
  'na-fr': 'carrieres',
  au: 'careers'
}

export const translatedCareersTitle: CareersTranslation = {
  en: 'Careers',
  uk: 'Careers',
  na: 'Careers',
  nl: 'Kom bij ons werken',
  fr: 'Nous rejoindre',
  pl: 'Praca w Refresco',
  de: 'Karriere',
  es: 'Únete al equipo',
  fi: 'Työskentely Refrescossa',
  it: 'Lavorare in Refresco',
  'na-fr': 'Carrières',
  au: 'Careers'
}

export type PageKind =
  | 'resource-overview'
  | 'search-overview'
  | 'vacancy-overview'
  | 'news-overview'
  | 'team-overview'
  | 'testimonial-overview'
export const pageKinds: PageKind[] = [
  'resource-overview',
  'search-overview',
  'vacancy-overview',
  'news-overview',
  'team-overview',
  'testimonial-overview'
]

export const pageKindToSlug = (pageKind: PageKind): string => {
  switch (pageKind) {
    case 'news-overview': {
      return 'actueel'
    }
    case 'vacancy-overview': {
      return 'vacancies'
    }
    case 'team-overview': {
      return 'medewerkers'
    }
    case 'testimonial-overview': {
      return 'testimonials'
    }
    default: {
      return pageKind
    }
  }
}

export const pageKindToTagList = (pageKind: PageKind): string[] => {
  switch (pageKind) {
    case 'resource-overview': {
      return [resourceTypeTags, resourceIndustryTags]
    }
    case 'news-overview': {
      return [newsTypeTags]
    }
    case 'vacancy-overview': {
      return [vacancyContract, vacancyCountry, vacancyLocation, vacancyDepartment, vacancyStateProvince]
    }
    case 'team-overview': {
      return [teamMemberDiscipline]
    }
    case 'testimonial-overview': {
      return [testimonialTags]
    }
    default: {
      return []
    }
  }
}

export const tagToTaxonomy = (tag: string): string => {
  switch (tag) {
    case resourceIndustryTags: {
      return 'resource_industry'
    }
    case resourceTypeTags: {
      return 'resource_type'
    }
    case newsTypeTags: {
      return 'news_type'
    }
    case vacancyContract: {
      return 'vacancyContract_type'
    }
    case vacancyCountry: {
      return 'vacancyCountry_type'
    }
    case vacancyStateProvince: {
      return 'vacancyStateProvince_type'
    }
    case vacancyLocation: {
      return 'vacancyLocation_type'
    }
    case vacancyDepartment: {
      return 'vacancyDepartment_type'
    }
    case teamMemberDiscipline: {
      return 'team-member_type'
    }
    case testimonialTags: {
      return 'testimonial_type'
    }
    case paperTypeTags: {
      return 'paper_type'
    }
    case eventTypeTags: {
      return 'event_type'
    }
    default: {
      return tag
    }
  }
}

export const tagUrlParameter = (tag: string): string => {
  switch (tag) {
    case resourceIndustryTags: {
      return 'resourceIndustryTag'
    }
    case resourceTypeTags: {
      return 'resourceTypeTag'
    }
    case newsTypeTags: {
      return 'newsTypeTag'
    }
    case vacancyContract: {
      return 'vacancyContractTypeTag'
    }
    case vacancyStateProvince: {
      return 'vacancyStateProvinceTag'
    }
    case vacancyCountry: {
      return 'vacancyCountryTag'
    }
    case vacancyLocation: {
      return 'vacancyLocationTag'
    }
    case vacancyDepartment: {
      return 'vacancyDepartmentTag'
    }
    case teamMemberDiscipline: {
      return 'teamMemberDisciplineTag'
    }
    case testimonialTags: {
      return 'testimonialTag'
    }
    default: {
      return tag
    }
  }
}

export const encodeTag = (tag: string): string => tag.replace(/&/g, '!<').replace(/,/g, '>!')

export const decodeTag = (tag: string): string => tag.replace(/!</g, '&').replace(/>!/g, ',')

export const resourceIndustryTags = 'resouceIndustryTags'
export const resourceTypeTags = 'resourceTypeTags'
export const newsTypeTags = 'newsTypeTags'
export const vacancyContract = 'vacancyContract'
export const vacancyStateProvince = 'vacancyStateProvince'
export const vacancyCountry = 'vacancyCountry'
export const vacancyLocation = 'vacancyLocation'
export const vacancyDepartment = 'vacancyDepartment'
export const teamMemberDiscipline = 'teamMemberDiscipline'
export const paperTypeTags = 'paperTypeTags'
export const eventTypeTags = 'eventTypeTags'
export const testimonialTags = 'testimonialTags'